// import React, { useState, useEffect } from "react";
// import styles from "../../styles/__uploadRequiredDocuments.module.scss";
// import { useDispatch, useSelector } from "react-redux";

// import { Link, useNavigate } from "react-router-dom";
// import { TriangleAlert } from "lucide-react";
// import { useTranslation } from "react-i18next";
// import { fetchConsultationReducer } from "../../reducer/consultation/fetchConsultationReducer";

// export default function UploadRequiredDocuments() {
//   const { t, i18n } = useTranslation();
//   const { data, loading, error } = useSelector((state) => state.consultation);
//   console.log("data:", data);
//   const [fields, setFields] = useState([
//     {
//       id: 6,
//       user_id: 21,
//       doc_type: "MEDICAL_LICENSE",
//       file_url:
//         "tiryaq-documents/doctors/medical-licenses/1762869858621_image-20250407-142156.png",
//       file_name: "image-20250407-142156.png",
//       status: "PENDING",
//       uploaded_at: "2025-11-11T14:04:30.427Z",
//       reviewed_at: null,
//       reviewer_id: null,
//       rejection_reason: null,
//       created_at: "2025-11-11T14:04:30.427Z",
//       updated_at: "2025-11-11T14:04:30.427Z",
//     },
//     {
//       id: 8,
//       user_id: 21,
//       doc_type: "ADDITIONAL_CERT",
//       file_url:
//         "tiryaq-documents/doctors/additional-certification/1762869868219_image-20250407-142156.png",
//       file_name: "image-20250407-142156.png",
//       status: "PENDING",
//       uploaded_at: "2025-11-11T14:04:30.427Z",
//       reviewed_at: null,
//       reviewer_id: null,
//       rejection_reason: null,
//       created_at: "2025-11-11T14:04:30.427Z",
//       updated_at: "2025-11-11T14:04:30.427Z",
//     },
//     {
//       id: 5,
//       user_id: 21,
//       doc_type: "GOV_ID",
//       file_url:
//         "tiryaq-documents/doctors/government-id/1762869855613_fixedCode-Q1N07LOJGXRVO35P2G.png",
//       file_name: "fixedCode-Q1N07LOJGXRVO35P2G.png",
//       status: "APPROVED",
//       uploaded_at: "2025-11-11T14:04:30.427Z",
//       reviewed_at: "2025-11-11T14:12:16.274Z",
//       reviewer_id: 1,
//       rejection_reason: null,
//       created_at: "2025-11-11T14:04:30.427Z",
//       updated_at: "2025-11-11T14:12:16.280Z",
//     },
//     {
//       id: 7,
//       user_id: 21,
//       doc_type: "DEGREE_CERTIFICATE",
//       file_url:
//         "tiryaq-documents/doctors/degree-certificates/1762869861570_image-20250407-142156.png",
//       file_name: "image-20250407-142156.png",
//       status: "REJECTED",
//       uploaded_at: "2025-11-11T14:04:30.427Z",
//       reviewed_at: "2025-11-11T14:12:21.399Z",
//       reviewer_id: 1,
//       rejection_reason: "Document rejected by admin",
//       created_at: "2025-11-11T14:04:30.427Z",
//       updated_at: "2025-11-11T14:12:21.402Z",
//     },
//   ]);
//   // const [fields, setFields] = useState([
//   //     { label: "Government ID", file:  new File(["dummy content"], "gov-id.pdf", { type: "application/pdf" }), filename: "File name.jpg", verification: false },
//   //     { label: "Medical Licenses", file: null, filename: "File name.jpg", verification: true },
//   //     { label: "Degree Certificates", file: null, filename: "File name.jpg", verification: true },
//   //     { label: "Profile Photo", file: null, filename: "File name.jpg", verification: true },
//   //     { label: "Additional Certification", file: null, filename: "File name.jpg", verification: true },
//   //   ]);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Files to upload:", fields);
//     // Upload logic here

//     navigate(`/dashboard`);
//   };

//   useEffect(() => {
//     dispatch(fetchConsultationReducer());
//   }, [dispatch]);

//   return (
//     <>
//       {/* <Header /> */}
//       <div className={styles["main-container"]}>
//         <main className={styles["main-content"]}>
//           <div className={styles["upload-content-wrapper"]}>
//             <form onSubmit={handleSubmit}>
//               <h2 className={styles["title-1"]}>{t("upload.title")}</h2>
//               <div className={styles["upload-grid"]}>
//                 {fields?.map((field, index) => (
//                   <div key={index} className={styles["upload-card"]}>
//                     <p className={styles["label"]}>{field.doc_type}</p>

//                     <label
//                       className={`${styles["upload-box"]} ${
//                         field.file_name ? styles["uploaded"] : ""
//                       }`}
//                     >
//                       <input type="file" accept=".png,.jpg,.jpeg,.pdf" hidden />
//                       <div className={styles["upload-placeholder"]}>
//                         <div className={styles["icon-wrap"]}>
//                           <span>
//                             <img src="/icon-upload.png" alt="" />
//                           </span>
//                         </div>
//                         <h2>{t("upload.placeholder.title")}</h2>
//                         <small>{t("upload.placeholder.subtitle")}</small>
//                       </div>
//                     </label>
//                     {field?.status == "PENDING" ? (
//                       <div className={styles["file-preview"]}>
//                         <span className={styles["file-icon"]}>
//                           <img src="/icon-jpg.png" alt="" />
//                         </span>
//                         <span className={styles["file-name"]}>
//                           {field.file_name}
//                         </span>
//                         <button type="button" className={styles["remove-btn"]}>
//                           ✖
//                         </button>
//                       </div>
//                     ) : field?.status == "APPROVED" ? (
//                       <div
//                         className={`${styles["file-preview"]} ${styles["rejected-file"]}`}
//                       >
//                          <span className={styles["file-icon"]}>
//                           <img src="/icon-jpg.png" alt="" />
//                         </span>
//                         <span className={styles["file-name"]}>
//                           {field.file_name}
//                         </span>
//                         <button type="button" className={styles["remove-btn"]}>
//                           ✖
//                         </button>
//                       </div>
//                     ) : (
//                       <div
//                         className={`${styles["file-preview"]} ${styles["rejected-file"]}`}
//                       >
//                         <span className={styles["file-icon"]}>
//                           {/* <img src="/file-rejected.png" alt="" /> */}
//                           <TriangleAlert />
//                         </span>
//                         <span className={styles["file-name"]}>
//                           <span className={styles["rejected-text"]}>
//                             {t("rejected")}
//                           </span>
//                           <p>{t("upload.valid")}</p>
//                         </span>
//                         <button type="button" className={styles["remove-btn"]}>
//                           ✖
//                         </button>
//                       </div>
//                     )}
//                   </div>
//                 ))}
//               </div>
//               <button
//                 type="submit"
//                 onClick={handleSubmit}
//                 className={styles["upload-btn"]}
//               >
//                 {t("upload.button.submit")}
//               </button>
//             </form>
//           </div>
//         </main>
//       </div>
//     </>
//   );
// }

// import React, { useState, useEffect } from "react";
// import styles from "../../styles/__uploadRequiredDocuments.module.scss";
// import { useDispatch, useSelector } from "react-redux";
// import { Link, useNavigate } from "react-router-dom";
// import { TriangleAlert } from "lucide-react";
// import { useTranslation } from "react-i18next";
// import { fetchConsultationReducer } from "../../reducer/consultation/fetchConsultationReducer";
// import useAxiosPrivate from "../../hooks/useAxiosPrivate";
// import { toast } from '../../components/app-toast';
// import { uploadedDoctorDocument } from "../../reducer/uploadedDoctorDocuments/uploadedDocReducer";
// import { uploadDoctorMedia } from "../../reducer/media/mediaReducer";

// export default function UploadRequiredDocuments() {
//   const { t } = useTranslation();
//   const { data, loading, error } = useSelector((state) => state.consultation);
//   const [fields, setFields] = useState([]);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const axiosPrivate = useAxiosPrivate();

//   useEffect(() => {
//     // ✅ Fetch consultation data when component loads
//     dispatch(fetchConsultationReducer());
//   }, [dispatch]);

//   useEffect(() => {
//     // If API response contains document data, set it here
//     if (data?.documents) {
//       setFields(data.documents);
//     }
//   }, [data]);
// // ✅ Handle Update Submit (PUT API)

// const docTypeMap = {
//   GOV_ID: "government-id",
//   MEDICAL_LICENSE: "medical-licenses",
//   DEGREE_CERTIFICATE: "degree-certificates",
//   ADDITIONAL_CERT: "additional-certification",
//   AVATAR: "triyaq-avatars",
// };

// // ✅ Convert File → Base64 for upload
// const convertToBase64 = (file) => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = (error) => reject(error);
//   });
// };

// // ✅ Handle file upload (replace old document)
// const handleFileChange = async (index, file) => {
//   if (!file) return;
//   try {
//     const base64Data = await convertToBase64(file);

//     // 👇 Upload to your S3 (use your existing uploadDoctorMedia or uploadAvatar thunk)
//     const response = await dispatch(
//       uploadDoctorMedia({
//         file_data: base64Data,
//         filename: file.name,
//         mime_type: file.type,
//         docType: fields[index]?.doc_type?.toLowerCase() || "document",
//       })
//     ).unwrap();

//     // ✅ Update field with new file URL + name
//     const newFields = [...fields];
//     newFields[index] = {
//       ...newFields[index],
//       file_name: file.name,
//       file_url: response?.file_url || response?.s3_key || "",
//       status: "PENDING",
//     };

//     setFields(newFields);
//     toast.success(`${file.name} uploaded successfully`);
//   } catch (error) {
//     console.error("File upload failed:", error);
//     toast.error("File upload failed. Please try again.");
//   }
// };

//   return (
//     <div className={styles["main-container"]}>
//       <main className={styles["main-content"]}>
//         <div className={styles["upload-content-wrapper"]}>
//           <form onSubmit={handleFileChange}>
//             <h2 className={styles["title-1"]}>{t("upload.title")}</h2>

//             <div className={styles["upload-grid"]}>
//               {fields?.map((field, index) => (
//                 <div key={index} className={styles["upload-card"]}>
//                   <p className={styles["label"]}>{field.doc_type}</p>

//                   <label
//                     className={`${styles["upload-box"]} ${
//                       field.file_name ? styles["uploaded"] : ""
//                     }`}
//                   >
//                     <input
//   type="file"
//   accept=".png,.jpg,.jpeg,.pdf"
//   hidden
//   onChange={(e) => handleFileChange(index, e.target.files?.[0] || null)}
// />
//                     <div className={styles["upload-placeholder"]}>
//                       <div className={styles["icon-wrap"]}>
//                         <span>
//                           <img src="/icon-upload.png" alt="" />
//                         </span>
//                       </div>
//                       <h2>{t("upload.placeholder.title")}</h2>
//                       <small>{t("upload.placeholder.subtitle")}</small>
//                     </div>
//                   </label>

//                   {/* ✅ Status Preview */}
//                   {field.status === "PENDING" && (
//                     <div className={styles["file-preview"]}>
//                       <span className={styles["file-icon"]}>
//                         <img src="/icon-jpg.png" alt="" />
//                       </span>
//                       <span className={styles["file-name"]}>{field.file_name}</span>
//                     </div>
//                   )}

//                   {field.status === "APPROVED" && (
//                     <div
//                       className={`${styles["file-preview"]} ${styles["approved-file"]}`}
//                     >
//                       <span className={styles["file-icon"]}>
//                         <img src="/icon-jpg.png" alt="" />
//                       </span>
//                       <span className={styles["file-name"]}>{field.file_name}</span>
//                     </div>
//                   )}

//                   {field.status === "REJECTED" && (
//                     <div
//                       className={`${styles["file-preview"]} ${styles["rejected-file"]}`}
//                     >
//                       <span className={styles["file-icon"]}>
//                         <TriangleAlert />
//                       </span>
//                       <span className={styles["file-name"]}>
//                         <span className={styles["rejected-text"]}>{t("rejected")}</span>
//                         <p>{field.rejection_reason || t("upload.valid")}</p>
//                       </span>
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>

//             <button type="submit" className={styles["upload-btn"]}>
//               {t("upload.button.submit")}
//             </button>
//           </form>
//         </div>
//       </main>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import styles from "../../styles/__uploadRequiredDocuments.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import { fetchConsultationReducer } from "../../reducer/consultation/fetchConsultationReducer";
import { updateDoctorDocument } from "../../reducer/updateUploadedDoctorDocuments/updateDoctorDocumentReducer";
import { uploadDoctorMedia } from "../../reducer/media/mediaReducer";
import { toast } from "../../components/app-toast";
import { useNavigate } from "react-router-dom";
import { isDoctorDocumentOptional } from "../../utils/doctorDocuments";
import useDoctorConsultationType from "../../hooks/useDoctorConsultationType";

// Verification documents every doctor is asked for. The degree certificate is
// optional for home-visit-only doctors, but its slot is always shown.
const DOCTOR_DOCUMENT_SLOTS = ["medical-licenses", "degree-certificates"];

export default function UploadRequiredDocuments() {
  const { t } = useTranslation();
  const { data } = useSelector((state) => state.consultation);
  const [fields, setFields] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Decides whether the degree certificate is optional (home visit only).
  // Prefer the value on the profile; the hook fetches it when it isn't cached.
  const fetchedConsultationType = useDoctorConsultationType();
  const consultationType =
    data?.user?.consultation_type || fetchedConsultationType;
  const isOptional = (docType) =>
    isDoctorDocumentOptional(docType, consultationType);

  // ✅ Backend expected doc types
  const docTypeMap = {
    GOV_ID: "government-id",
    MEDICAL_LICENSE: "medical-licenses",
    DEGREE_CERTIFICATE: "degree-certificates",
    AVATAR: "triyaq-avatars",
  };

  // 🔹 Convert any uppercase doc_type to correct API format
  const normalizeDocType = (docType) => {
    if (!docType) return "";
    return docTypeMap[docType] || docType; // map if possible
  };

  useEffect(() => {
    dispatch(fetchConsultationReducer());
  }, [dispatch]);

  useEffect(() => {
    const normalizedDocs = (data?.documents || []).map((d) => ({
      ...d,
      doc_type: normalizeDocType(d.doc_type),
    }));
    // Add an empty slot for every document not uploaded yet, so a home-visit
    // doctor who skipped the optional degree certificate can still add it later
    // (e.g. when re-uploading after a rejection).
    const emptySlots = DOCTOR_DOCUMENT_SLOTS.filter(
      (docType) => !normalizedDocs.some((d) => d.doc_type === docType),
    ).map((docType) => ({
      doc_type: docType,
      file_name: null,
      file_url: null,
      status: null,
    }));
    setFields([...normalizedDocs, ...emptySlots]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  // ✅ Convert File → Base64
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  // ✅ Handle file upload
  const handleFileChange = async (index, file) => {
    if (!file) return;
    try {
      const base64Data = await convertToBase64(file);

      const response = await dispatch(
        uploadDoctorMedia({
          file_data: base64Data,
          filename: file.name,
          mime_type: file.type,
          docType: fields[index]?.doc_type || "document",
        }),
      ).unwrap();

      const newFields = [...fields];
      newFields[index] = {
        ...newFields[index],
        file_name: file.name,
        file_url: response?.file_url || response?.s3_key || "",
        status: "PENDING",
      };
      setFields(newFields);
      // Toast is already shown in the reducer, no need to show it here
    } catch (error) {
      console.error("File upload failed:", error);
      // Toast is already shown in the reducer, no need to show it here
    }
  };

  const isUploaded = (field) =>
    Boolean(field.file_url && field.file_url.trim() !== "");

  // ✅ Check if every REQUIRED document is uploaded. The degree certificate is
  // optional for home-visit-only doctors, so it doesn't block submitting.
  const areAllDocumentsUploaded = () => {
    return (
      fields.length > 0 &&
      fields.every((field) => isOptional(field.doc_type) || isUploaded(field))
    );
  };

  // ✅ Handle Submit (PUT API)
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate all documents are uploaded
    if (!areAllDocumentsUploaded()) {
      toast.warning(t("upload.toast.uploadAllRequired"));
      return;
    }

    const payload = {
      // Only send documents that have a file; an optional one left empty is skipped.
      documents: fields.filter(isUploaded).map((f) => ({
        doc_type: normalizeDocType(f.doc_type),
        file_url: f.file_url,
        file_name: f.file_name,
        status: f.status || "PENDING",
      })),
    };

    console.log("🚀 Final payload to API:", payload);

    try {
      await dispatch(updateDoctorDocument(payload)).unwrap();
      // Toast is already shown in the reducer, no need to show it here
      // Navigate to documents-under-process page after successful submission
      navigate("/documents-under-process");
    } catch (error) {
      console.error("❌ Error updating documents:", error);
      // Toast is already shown in the reducer, no need to show it here
    }
  };

  return (
    <>
      <div className={styles["main-container"]}>
        <main className={styles["main-content"]}>
          <div className={styles["upload-content-wrapper"]}>
            <form onSubmit={handleSubmit}>
              <h2 className={styles["title-1"]}>{t("upload.title")}</h2>

              <div className={styles["upload-grid"]}>
                {fields?.map((field, index) => (
                  <div key={index} className={styles["upload-card"]}>
                    {/* Required documents get a red asterisk; the degree
                        certificate is marked "(Optional)" for home-visit-only
                        doctors instead. */}
                    <p className={styles["label"]}>
                      {t(field.doc_type) || field.doc_type}
                      {isOptional(field.doc_type) ? (
                        ` ${t("upload.optional")}`
                      ) : (
                        <span className={styles["required"]} aria-hidden="true">
                          *
                        </span>
                      )}
                    </p>

                    <label
                      className={`${styles["upload-box"]} ${
                        field.file_name ? styles["uploaded"] : ""
                      }`}
                    >
                      <input
                        type="file"
                        accept=".png,.jpg,.jpeg,.pdf"
                        hidden
                        onChange={(e) =>
                          handleFileChange(index, e.target.files?.[0] || null)
                        }
                      />
                      <div className={styles["upload-placeholder"]}>
                        <div className={styles["icon-wrap"]}>
                          <span>
                            <img src="/icon-upload.png" alt="" />
                          </span>
                        </div>
                        <h2>{t("upload.placeholder.title")}</h2>
                        <small>{t("upload.placeholder.subtitle")}</small>
                      </div>
                    </label>

                    {/* ✅ Status View */}
                    {field.status === "PENDING" && (
                      <div className={styles["file-preview"]}>
                        <span className={styles["file-icon"]}>
                          <img src="/icon-jpg.png" alt="" />
                        </span>
                        <span className={styles["file-name"]}>
                          {field.file_name}
                        </span>
                      </div>
                    )}

                    {field.status === "APPROVED" && (
                      <div
                        className={`${styles["file-preview"]} ${styles["approved-file"]}`}
                      >
                        <span className={styles["file-icon"]}>
                          <img src="/icon-jpg.png" alt="" />
                        </span>
                        <span className={styles["file-name"]}>
                          {field.file_name}
                        </span>
                      </div>
                    )}

                    {field.status === "REJECTED" && (
                      <div
                        className={`${styles["file-preview"]} ${styles["rejected-file"]}`}
                      >
                        <span className={styles["file-icon"]}>
                          <TriangleAlert />
                        </span>
                        <span className={styles["file-name"]}>
                          <span className={styles["rejected-text"]}>
                            {t("rejected")}
                          </span>
                          <p>{field.rejection_reason || t("upload.valid")}</p>
                        </span>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <button
                type="submit"
                className={styles["upload-btn"]}
                disabled={!areAllDocumentsUploaded()}
                style={{
                  opacity: !areAllDocumentsUploaded() ? 0.5 : 1,
                  cursor: !areAllDocumentsUploaded()
                    ? "not-allowed"
                    : "pointer",
                }}
              >
                {t("upload.button.submit")}
              </button>
            </form>
          </div>
        </main>
      </div>
    </>
  );
}
